export const queryPage = '/transfer/outer/transfer/datasource/query_page'
export const saveOrUpdate = '/transfer/outer/transfer/datasource/save_or_update'
import request from '@/utils/request'
export function update_status(params) {
  return request({
    url: '/transfer/outer/transfer/datasource/update_status',
    method: 'get',
    params
  })
}
export function get_dbdriver(params) {
  return request({
    url: '/transfer/outer/transfer/datasource/get_dbdriver',
    method: 'get',
    params
  })
}